module.exports = __webpack_public_path__ + "static/transaction_fee_management1-ea8ec64037b3bd560d44f615be42772f.png";